import { db } from "./db"

export function login(username, password) {
    return db('post', 'auth-api/api/authentication/login', { username, password })
}